import type { IBotUsageStatsRowApi } from '@/types/botUsageStats';

export class BotUsageStatsItem {
    public betCount: number;
    public betPerc: number;
    public botCount: number;
    public botCountActive: number;
    public botPerc: number;
    public botPercActive: number;
    public id: number;
    public isUseMinStake: number | null;
    public name: string;

    constructor(data: IBotUsageStatsRowApi) {
        this.id = data.id;
        this.name = data.name;
        this.botCount = data.bot_count ?? 0;
        this.botCountActive = data.bot_count_active ?? 0;
        this.betCount = data.bet_count ?? 0;
        this.botPerc = data.bot_perc ?? 0;
        this.botPercActive = data.bot_perc_active ?? 0;
        this.betPerc = data.bet_perc ?? 0;
        this.isUseMinStake = data.is_use_min_stake ?? null;
    }

    get betPercDisplay(): string {
        return formatUsagePerc(this.betPerc);
    }

    get botPercActiveDisplay(): string {
        return formatUsagePerc(this.botPercActive);
    }

    get botPercDisplay(): string {
        return formatUsagePerc(this.botPerc);
    }
}

function formatUsagePerc(value: number): string {
    return `${parseFloat(value.toFixed(2))}%`;
}
